import {Injectable} from '@angular/core';
import { Subject, Observable, EMPTY } from "rxjs";
import {HttpClient, HttpParams} from "@angular/common/http";

@Injectable()
export class SharedDataService {

  private OBJ_subjects = {};


  constructor (private OBJ_http: HttpClient) {}


    /**
     * Function > createSubject
     *
     * @desc Erstelle ein Subject fuer ein bestimmtes Feld
     * @param STR_fieldname
     */
  createSubject(STR_fieldname: string) {
    this.OBJ_subjects[STR_fieldname] = new Subject<string>();
  } // end function createSubject


  /**
   * Function > sendSTR_value
   * @param {string} STR_fieldname
   * @param {string} STR_value
   */
  sendValue(STR_fieldname: string, STR_value: string)
  {

    if(this.OBJ_subjects[STR_fieldname])
    {
      this.OBJ_subjects[STR_fieldname].next(STR_value);
    } // end if

  } // end function sendSTR_value


  /**
   * Function > getValue
   *
   * @param {string} STR_fieldname
   * @return {Observable<any>}
   */
  getValue(STR_fieldname: string): Observable<any>
  {

    if (this.OBJ_subjects[STR_fieldname])
    {
      return this.OBJ_subjects[STR_fieldname].asObservable();
    }
    else
    {
		return EMPTY;
    } // end if

  } // end function getValue


  /**
   * Function > clearSTR_value
   *
   * @desc Setze den Wert zurueck
   * @param STR_fieldname
   */
  clearValue(STR_fieldname)
  {

    if(this.OBJ_subjects[STR_fieldname])
    {
      this.OBJ_subjects[STR_fieldname].next();
    } // end if

  } // end function clearSTR_value


  /**
   * Function > getContents
   *
   * @param {string} STR_url
   * @param {boolean} BOO_search
   * @param {string} STR_search
   * @param {string} STR_searchfields
   * @param {string} STR_sort_by
   * @param {string} STR_order
   * @param {number} INT_limit
   * @param {number} INT_skip
   *
   * @return Observable<any>
   */
  getContents(STR_url: string, BOO_search = false, STR_search = '', STR_searchfields = "", STR_sort_by = "", STR_order = "asc", INT_limit = 1000, INT_skip = 0): Observable<any>
  {

    // set http params
    let OBJ_params = new HttpParams();
    if (STR_search.length > 0) {
      OBJ_params = OBJ_params.set('searchtext', STR_search)
                             .set('searchfields', STR_searchfields);
    }

    if (!BOO_search) {
      OBJ_params = OBJ_params.set('skip', INT_skip.toString())
                             .set('limit', INT_limit.toString());
      if (STR_sort_by.length > 0) {
        OBJ_params = OBJ_params.set('sort_by', STR_sort_by)
                               .set('order', STR_order);
      }

    }

    return this.OBJ_http.get(STR_url, {
      params: OBJ_params,
      observe: 'response'
    });

  }


} // end class SharedDataService
